export default __webpack_public_path__ + "static/media/arrow-right.02f1df8d.svg";